import { SEND_FEEDBACK, SEND_FEEDBACK_ERROR } from './types';

import { Feedback } from './api';

export const sendFeedbackAction = (
  body,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Feedback.send(body);
  setSubmitting(false);
  if (!response.error) {
    dispatch({ type: SEND_FEEDBACK, payload: response.data });
  } else {
    dispatch({ type: SEND_FEEDBACK_ERROR });
    setSubmitting(false);
  }
  return response;
};



// WEBPACK FOOTER //
// ./src/store/modules/feedback/actions.js